module.exports = __webpack_public_path__ + "static/media/tsc-cards.d4739268.png";